const reviewPositionFillRequestValidation = {
  decision: {
    type: 'enum',
    required: true,
  },
};

export default reviewPositionFillRequestValidation;
